import { useMemo, useState } from "react";
import {
  List,
  TextField,
  // WrapperField,
  DatagridConfigurable,
  // WithRecord,
  DateField,
  ReferenceField,
  FunctionField,
  usePermissions,
} from "react-admin";
import CorrectionAddDialog from "../../components/corrections/create/CorrectionAddDialog";
import CorrectionEditDialog from "../../components/corrections/edit/CorrectionEditDialog";
import correctionFilterList from "../../components/corrections/filter/correctionFilterList";
// import EditBtn from "../../components/editBtn/EditBtn";
import TableListActions from "../../components/tableListActions/TableListActions";
import CompleteWithCustomExportActions from "../../components/tableListActions/CompleteWithCustomExportActions";

const CorrectionList = () => {
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();
  const { permissions } = usePermissions();

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };

  const itemLineStyle = (index, total) => ({
    minHeight: "30px",
    padding: "5px 0",
    borderBottom:
      index < total - 1 ? "1px solid rgba(255,255,255,0.18)" : "none",
    boxSizing: "border-box",
  });

  const getCorrectionCode = (record) =>
    record.correction_in?.code || record.correction_out?.code || "";
  // const handleClickOpenEdit = (recId) => () => {
  //   setRecordId(recId);
  //   setOpenEdit(true);
  // };
  const list = useMemo(
    () => (
      <List
        title="Koreksi Stok"
        empty={false}
        actions={
          <CompleteWithCustomExportActions createHandler={handleClickOpenAdd} />
        }
        filters={correctionFilterList(permissions)}
        filter={{ type: "adj" }}
        sort={{ field: "created_at", order: "DESC" }}
        // filterDefaultValues={{ type: "adj" }}
        // queryOptions={{ meta: { sort: ["id DESC"] } }} // overide default sort
        sx={{
          "& .RaList-main > .MuiToolbar-root": {
            flexDirection: "column",
            alignItems: "baseline",
          },
        }}
      >
        <DatagridConfigurable>
          {permissions && !permissions.includes("admin_depo") ? (
            <TextField source="company.alias" label="Depo" />
          ) : null}
          <FunctionField
            label="mine.label.code"
            render={(record) => {
              return getCorrectionCode(record);
            }}
          />
          <FunctionField
            label="mine.label.product"
            render={(record) => {
              const items = (record.product_adjs || []).filter((item) => item.mutation !== 0);
              return items.map((item, index) => (
                <div key={item.id || `${record.id}-product-${index}`} style={itemLineStyle(index, items.length)}>
                  {item.product?.name || "-"}
                </div>
              ));
            }}
          />
          <FunctionField
            label="mine.label.amount"
            render={(record) => {
              const items = (record.product_adjs || []).filter((item) => item.mutation !== 0);
              return items.map((item, index) => (
                <div key={item.id || `${record.id}-amount-${index}`} style={{ ...itemLineStyle(index, items.length), textAlign: "right" }}>
                  {item.mutation}
                </div>
              ));
            }}
          />
          <TextField source="note" label="mine.label.note" />
          <DateField
            source="created_at"
            label="mine.tbl_header.created_at"
            showTime
          />
          <ReferenceField
            label="mine.tbl_header.created_by"
            source="created_by"
            reference="users/some"
          >
            <TextField source="username" />
          </ReferenceField>
          {/* <WrapperField label="Actions">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField> */}
        </DatagridConfigurable>
      </List>
    ),
    []
  );
  return (
    <>
      {list}
      {openAdd ? (
        <CorrectionAddDialog open={openAdd} setOpen={setOpenAdd} />
      ) : null}
      {openEdit ? (
        <CorrectionEditDialog
          open={openEdit}
          setOpen={setOpenEdit}
          recordId={recordId}
        />
      ) : null}
    </>
  );
};

export default CorrectionList;
